import styles from "./OnboardingVolunteer.module.scss";
import classNames from "classnames";
import { useEnumStore } from "../../store/enumStore";
import { EventInterestsSkillsSection } from "../EventInterestsSkillsSection/EventInterestsSkillsSection";
import {
  InputMunicipality,
  MunicipalitySuggestion,
} from "../InputMunicipality/InputMunicipality";

interface OnboardingVolunteerSecondStepProps {
  title: string;
  desc: string;
  formData: {
    skills: string[];
    interests: string[];
    locations: MunicipalitySuggestion[];
  };
  onCheckboxToggle: (id: string, field: "skills" | "interests") => void;
  selectedTowns: MunicipalitySuggestion[];
  onSetSelectedTowns: (towns: MunicipalitySuggestion[]) => void;
}

export const OnboardingVolunteerSecondStep = ({
  title,
  desc,
  formData,
  onCheckboxToggle,
  selectedTowns,
  onSetSelectedTowns,
}: OnboardingVolunteerSecondStepProps) => {
  const skills = useEnumStore((state) => state.skills);

  return (
    <div className={classNames(styles.content)}>
      <h2>Lokalita</h2>
      <p>Zvolte prosím alespoň 1 lokalitu, ve které chcete pomáhat.</p>
      <InputMunicipality
        selectedTowns={selectedTowns}
        onTownsChange={onSetSelectedTowns}
        label="Lokalita"
      />
      <h2>{title}</h2>
      <p>{desc}</p>
      <EventInterestsSkillsSection
        title=""
        items={skills as any}
        selectedIds={formData.skills}
        onToggle={(id) => onCheckboxToggle(id, "skills")}
        editMode={true}
        userType="volunteer"
        showSubItems={true}
        type="skills"
      />
    </div>
  );
};
